import React from 'react'

interface DirectionCardProps {
  title: string
}

const DirectionCard: React.FC<DirectionCardProps> = ({ title }) => {
  return (
    <div className="border bg-navy-900 bg-opacity-5 w-full h-full rounded-[2px] py-1">
      <p className="text-center font-bold text-navy-900">{title}</p>
    </div>
  )
}

export default DirectionCard
